import { module as BaseModule } from "modujs";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import MobileSearchOverlay from "../components/algolia/MobileSearchOverlay.jsx";

const SELECTORS = {
  trigger: ".g-header__mobile-search-trigger",
};

const BREAKPOINT_QUERY = "(min-width: 1024px)";

export default class MobileSearch extends BaseModule {
  init() {
    this.trigger = this.el.querySelector(SELECTORS.trigger);

    if (!this.trigger) {
      return;
    }

    this.mountTarget = document.createElement("div");
    this.mountTarget.className = "g-header__mobile-search-root";
    this.el.appendChild(this.mountTarget);

    this.isOpen = false;

    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleMediaChange = this.handleMediaChange.bind(this);

    this.attachTriggerListener();
    this.attachMediaQueryListener();
    this.render();
  }

  attachTriggerListener() {
    if (!this.trigger) {
      return;
    }
    this.trigger.addEventListener("click", this.handleTriggerClick);
  }

  detachTriggerListener() {
    if (!this.trigger) {
      return;
    }
    this.trigger.removeEventListener("click", this.handleTriggerClick);
  }

  attachMediaQueryListener() {
    if (typeof window === "undefined" || !window.matchMedia) {
      return;
    }

    this.mediaQuery = window.matchMedia(BREAKPOINT_QUERY);
    this.mediaQuery.addEventListener("change", this.handleMediaChange);
    this.handleMediaChange(this.mediaQuery);
  }

  detachMediaQueryListener() {
    if (this.mediaQuery) {
      this.mediaQuery.removeEventListener("change", this.handleMediaChange);
      this.mediaQuery = null;
    }
  }

  handleTriggerClick(event) {
    event.preventDefault();
    this.isOpen = true;
    this.render();
  }

  handleClose() {
    if (!this.isOpen) {
      return;
    }
    this.isOpen = false;
    this.render();
  }

  handleMediaChange(event) {
    if (event.matches && this.isOpen) {
      this.handleClose();
    }
  }

  render() {
    if (!this.mountTarget) {
      return;
    }

    if (!this.reactRoot) {
      this.reactRoot = createRoot(this.mountTarget);
    }

    this.reactRoot.render(
      createElement(MobileSearchOverlay, {
        isOpen: this.isOpen,
        onClose: this.handleClose,
      })
    );
  }

  destroy() {
    this.detachTriggerListener();
    this.detachMediaQueryListener();

    if (this.reactRoot) {
      this.reactRoot.unmount();
      this.reactRoot = null;
    }

    if (this.mountTarget) {
      this.mountTarget.remove();
      this.mountTarget = null;
    }

    this.trigger = null;
    this.isOpen = false;
  }
}
